import { createTheme } from '@mui/material/styles';

let theme = createTheme({
	palette: {
		primary: {
			light: '#dbd9d6', //UPMC_WHITE
			main: '#771b61', //UPMC_PURPLE
			dark: '#4d104a', //UPMC_DARK_PURPLE
			contrastText: '#fff', //white
		},
		secondary: {
			light: '#dbd9d6', //UPMC_WHITE
			main: '#904199', //TECH_PURPLE
			dark: '#363533', //UPMC_BLACK
			contrastText: '#000', //black
		},
		grayscale: {
			main: '#9e9e9e',
			dark: '#424242',
			light: '#f5f5f5',
		},
	},
	typography: {
		fontFamily: ['Montserrat, sans-serif'],
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			xl: 1920,
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiCard: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					margin: '5px',
					padding: '8px',
					...(ownerState.small && {
						width: '25%',
					}),
					...(ownerState.medium && {
						width: '50%',
					}),
					...(ownerState.large && {
						width: '75%',
					}),
					...(ownerState.xlarge && {
						width: '100%',
					}),
				}),
			},
		},
		MuiDialog: {
			styleOverrides: {
				root: {
					'& .MuiBackdrop-root': {
						backgroundColor: `rgba(${theme.palette.secondary.contrastText
							.split('')
							.slice(1)}, .32)`,
					},
					fontFamily: theme.typography.fontFamily,
				},
			},
		},
		MuiDialogTitle: {
			styleOverrides: {
				root: {
					paddingBottom: '8px',
				},
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					color: `rgba(${theme.palette.secondary.contrastText
						.split('')
						.slice(1)}, .6)`,
					'> :first-child': {
						marginTop: '0px',
					},
					'> :last-child': {
						marginBottom: '0px',
					},
				},
			},
		},
		MuiSnackbar: {
			defaultProps: {
				anchorOrigin: {
					horizontal: 'center',
					vertical: 'bottom',
				},
			},
		},
		MuiSnackbarContent: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.primary.main,
					minWidth: '100px !important',
				},
				action: {
					'> button': {
						backgroundColor: 'white',
						'&:hover': {
							backgroundColor: theme.palette.grey.A100,
						},
					},
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					'&:hover': {
						backgroundColor: theme.palette.grey.A100,
					},
					fontSize: '14px',
					minHeight: '48px',
				},
			},
		},
	},
});

export { theme };
